/**
 * Types, interfaces, enums, and default translations for rule utilities.
 */
/**
 * Default English translations
 */
export const defaultEnglishTranslations = {
    everyTime: 'every time',
    then: 'then',
    and: 'and',
    or: 'or',
    conditions: {
        descriptionContainsExactly: 'the description contains exactly',
        descriptionContainsInOrder: 'the description contains all the following words',
        descriptionContainsAny: 'the description contains any of the following words',
        descriptionContains: 'the description contains',
        descriptionDoesNotContain: 'the description does not contain',
        descriptionStartsWith: 'the description starts with',
        descriptionEndsWith: 'the description ends with',
        amountGreaterThan: 'the amount is greater than',
        amountGreaterOrEqual: 'the amount is greater than or equal to',
        amountLessThan: 'the amount is less than',
        amountLessOrEqual: 'the amount is less than or equal to',
        amountEquals: 'the amount equals',
        amountBetween: 'the amount is between',
        currencyIs: 'the currency is',
        accountIs: 'the account is',
        dateStartingFrom: 'the date is on or after',
        dateUntil: 'the date is on or before',
        dateBetween: 'the date is between',
        dateOn: 'the date is',
    },
    actions: {
        setCategory: 'set the category to',
        addTag: 'add the tag',
        addNote: 'add the note',
        setAccount: 'set the account to',
        setMerchant: 'set the merchant to',
    },
};
